import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { PageNotFound } from '@components/common';
import AccessWrapper from '@components/common/Dashboard/DashboardTabs/AccessWrapper';
import featureNames from '@utils/featureToggle/constants';
import { homePagePath, singleAppPrefix } from './utils';

const { baseUrl } = window.conviva;

import {
  NocPage,
  ExperienceDashboardPage,
  MetricLensPage,
  AiAlertsPage,
  TempDashboardNocRoute,
  DashboardNocRoute,
  NocSharingRoute,
  TempDashboardErrorDiagnosticsRoute,
  DashboardErrorDiagnosticsRoute,
  ErrorDiagnosticsSharingRoute,
  TempTimelineRoute,
  SavedTimelineRoute,
  TimelineSharingRoute,
  ViewerModulePage,
  ResiliencyPolicyPage,
  VideoAIAlertsCohorts,
  RemountHoC,
  NavigateWithParams,
  RedirectToHomePage,
  TrendsPage,
  NexaDashboard,
} from './FeatureCheck';

import {
  Main,
  CustomDashboard,
  TrendsSharing,
  CompareSharing,
  Admin,
  PrecisionPolicy,
  MbrPolicy,
  ChangeLog,
  MLSharingDashboard,
  MLSavedDashboard,
  Alert,
  SavedDashboards,
  Profile,
  ErrorConfig,
  TempNocDrilldownDashboard,
  OverviewSharingDashboard,
  OverviewSavedDashboard,
  VMSharingDashboard,
  VMSavedDashboard,
  AiAlertDiagnostics,
  PreAiAlertDiagnostics,
  PreAdAiAlertDiagnostics,
  TrendsSavedDashboard,
  Prompt,
  TempDashboard,
  AIRoadmapPage,
  WebhooksListPage,
  WebhooksEditPage,
  AccountDetails,
} from '../pages';
import PresetDashboardPage from './PresetDashboards';
import TempVdashDrilldownDashboard from '@src/pages/VdashDrillDown';
import DrilldownDashboard from '@src/pages/main/DrilldownDashboard';
import TempDashboards from '@src/pages/SavedDashboards/TempDashboards';

import {
  CHANGE_LOG_PATH,
  PRECISION_POLICY_PATH,
  PRECISION_RESILIENCY_PATH,
  MBR_POLICY_PATH,
  PRESET_DASHBOARD_ROUTE_PATH,
} from '@utils/constants';

import { MyProfile } from '../pages/MyProfile';

import TrackingPolicy from '../pages/TrackingPolicy/Summary';
import PolicyDetails from '../pages/TrackingPolicy/Detail';

import Nexa from '@src/pages/Nexa';
import RedirectToNexaWithId from '@src/pages/Nexa/RedirectToNexaWithId';
import AskNexa from '@src/pages/Nexa/AskNexa';
import NexaSharedView from '@src/pages/Nexa/SharedView';

import SsdPanel from '@src/pages/ssd';
import SessionTagPanel from '@src/pages/sessionTags';

import AlertRuleListPage from '../pages/AIAlertForward';
import AlertRuleDetailPage from '../pages/AIAlertForward/editRule';

const VideoAdRouter = () => {
  return (
    <Routes>
      <Route path={homePagePath} element={<RedirectToHomePage />} />
      <Route path={`${baseUrl}/dashboard/trends`} element={<TrendsPage />} />
      <Route path={`${baseUrl}/dashboard/prompt`} element={<Prompt />} />

      <Route path={PRESET_DASHBOARD_ROUTE_PATH} element={<PresetDashboardPage />} />

      <Route
        path={`${baseUrl}/dashboard/trends/sharing/:id`}
        element={<RemountHoC Component={TrendsSharing} />}
      />
      <Route path={`${baseUrl}/dashboard/trends/saved/:id`} element={<TrendsSavedDashboard />} />
      <Route
        path={`${baseUrl}/dashboard/ai-alerts/diagnostics/sharing/:id`}
        element={<RemountHoC Component={TrendsSharing} />}
      />
      <Route path={`${baseUrl}/dashboard/trends/:id`} element={<Main />} />
      <Route path={`${baseUrl}/dashboard/trends/modify-real-time`} element={<Main />} />
      <Route
        path={`${baseUrl}/dashboard/trends/rt-drilldown/:id`}
        element={<RemountHoC Component={TempNocDrilldownDashboard} />}
      />
      <Route
        path={`${baseUrl}/dashboard/trends/cd-drilldown/:id`}
        element={<RemountHoC Component={TempVdashDrilldownDashboard} />}
      />
      <Route
        path={`${baseUrl}/dashboard/trends/ba-drilldown/:id`}
        element={<RemountHoC Component={TempNocDrilldownDashboard} />}
      />

      <Route
        path={`${baseUrl}/dashboard/trends/na-drilldown/:id`}
        element={<RemountHoC Component={TempNocDrilldownDashboard} />}
      />
      <Route
        path={`${baseUrl}/dashboard/trends/drilldown/:id`}
        element={<RemountHoC Component={DrilldownDashboard} />}
      />

      <Route
        path={`${baseUrl}/dashboard/noc/:id`}
        element={<NavigateWithParams to={`${baseUrl}/dashboard/real-time/:id`} />}
      />

      <Route
        path={`${baseUrl}/dashboard/noc/sharing/:id`}
        element={<NavigateWithParams to={`${baseUrl}/dashboard/real-time/sharing/:id`} />}
      />

      <Route
        path={`${baseUrl}/dashboard/noc/temp/:id`}
        element={<NavigateWithParams to={`${baseUrl}/dashboard/real-time/temp/:id`} />}
      />

      <Route
        path={`${baseUrl}/dashboard/noc`}
        element={<Navigate to={`${baseUrl}/dashboard/real-time`} replace />}
      />

      {/* for some customer may have saved new-real-time URL */}
      <Route
        path={`${baseUrl}/dashboard/new-real-time/:id`}
        element={<NavigateWithParams to={`${baseUrl}/dashboard/real-time/:id`} />}
      />

      <Route
        path={`${baseUrl}/dashboard/new-real-time/sharing/:id`}
        element={<NavigateWithParams to={`${baseUrl}/dashboard/real-time/sharing/:id`} />}
      />

      <Route
        path={`${baseUrl}/dashboard/new-real-time/temp/:id`}
        element={<NavigateWithParams to={`${baseUrl}/dashboard/real-time/temp/:id`} />}
      />

      <Route
        path={`${baseUrl}/dashboard/new-real-time`}
        element={<Navigate to={`${baseUrl}/dashboard/real-time`} replace />}
      />

      <Route path={`${baseUrl}/dashboard/real-time`} element={<NocPage />} />
      <Route path={`${baseUrl}/dashboard/real-time/:id`} element={<DashboardNocRoute />} />
      <Route path={`${baseUrl}/dashboard/real-time/sharing/:id`} element={<NocSharingRoute />} />
      <Route path={`${baseUrl}/dashboard/real-time/temp/:id`} element={<TempDashboardNocRoute />} />

      <Route
        path={`${baseUrl}/dashboard/metriclens/sharing/:id`}
        element={<MLSharingDashboard />}
      />
      <Route path={`${baseUrl}/dashboard/metriclens`} element={<MetricLensPage />} />
      <Route path={`${baseUrl}/dashboard/metriclens/:id`} element={<MLSavedDashboard />} />

      <Route path={`${baseUrl}/dashboard/compare/sharing/:id`} element={<CompareSharing />} />
      <Route path={`${baseUrl}/dashboard/compare/:id`} element={<CustomDashboard />} />

      {/* Admin route will be depricated in a future release */}
      <Route
        path={`${singleAppPrefix}/admin/apps/*`}
        element={<Navigate to={`${singleAppPrefix}/manage/apps/list`} replace />}
      />

      <Route path={`${singleAppPrefix}/manage/*`} element={<Admin />} />
      <Route
        path={`${singleAppPrefix}/precision/precision_policy`}
        element={<Navigate to={`${PRECISION_POLICY_PATH}`} />}
        replace
      />
      <Route path={`${PRECISION_POLICY_PATH}`} element={<PrecisionPolicy />} />
      <Route path={`${PRECISION_RESILIENCY_PATH}`} element={<ResiliencyPolicyPage />} />
      <Route path={`${CHANGE_LOG_PATH}`} element={<ChangeLog />} />
      <Route path={`${MBR_POLICY_PATH}`} element={<MbrPolicy />} />

      {/* feature migrated to trends */}
      <Route
        path={`${baseUrl}/dashboard/error-diagnostics/:id`}
        element={<DashboardErrorDiagnosticsRoute />}
      />
      <Route
        path={`${baseUrl}/dashboard/error-diagnostics/sharing/:id`}
        element={<ErrorDiagnosticsSharingRoute />}
      />
      <Route
        path={`${baseUrl}/dashboard/error-diagnostics/temp/:id`}
        element={<TempDashboardErrorDiagnosticsRoute />}
      />

      <Route path={`${baseUrl}/dashboard/timeline/:id`} element={<SavedTimelineRoute />} />
      <Route path={`${baseUrl}/dashboard/timeline/temp/:id`} element={<TempTimelineRoute />} />
      <Route
        path={`${baseUrl}/dashboard/timeline/sharing/:id`}
        element={<TimelineSharingRoute />}
      />

      <Route
        path={`${baseUrl}/dashboard/viewer-module/:viewerId/sharing/:id`}
        element={<VMSharingDashboard />}
      />
      <Route path={`${baseUrl}/dashboard/viewer-module/saved/:id`} element={<VMSavedDashboard />} />
      <Route path={`${baseUrl}/dashboard/viewer-module`} element={<ViewerModulePage />} />
      <Route path={`${baseUrl}/dashboard/viewer-module/:viewerId`} element={<ViewerModulePage />} />
      <Route
        path={`${baseUrl}/dashboard/viewer-module/:viewerId/temp/:id`}
        element={<ViewerModulePage />}
      />

      <Route path={`${baseUrl}/alert/*`} element={<Alert />} />
      <Route path={`${baseUrl}/dashboard/saved-dashboards`} element={<SavedDashboards />} />
      <Route path={`${baseUrl}/dashboard/temp-dashboards`} element={<TempDashboards />} />

      <Route path={`${baseUrl}/dashboard/error-config`} element={<ErrorConfig />} />

      <Route path={`${baseUrl}/dashboard/policies-tracking/summary`} element={<TrackingPolicy />} />
      <Route path={`${baseUrl}/dashboard/policies-tracking/detail`} element={<PolicyDetails />} />

      <Route path={`/app/settings/alert-forward-list`} element={<AlertRuleListPage />} />
      <Route path={`/app/settings/alert-forward-edit`} element={<AlertRuleDetailPage />} />

      <Route
        path={`${baseUrl}/dashboard/overview/sharing/:id`}
        element={
          <AccessWrapper
            feature={featureNames.EXPERIENCE_DASHBOARD}
            fallback={<Navigate to={`${baseUrl}/dashboard/trends`} replace />}
          >
            <OverviewSharingDashboard />
          </AccessWrapper>
        }
      />
      <Route
        path={`${baseUrl}/dashboard/overview/:id`}
        element={
          <AccessWrapper
            feature={featureNames.EXPERIENCE_DASHBOARD}
            fallback={<Navigate to={`${baseUrl}/dashboard/trends`} replace />}
          >
            <OverviewSavedDashboard />
          </AccessWrapper>
        }
      />
      <Route path={`${baseUrl}/dashboard/overview`} element={<ExperienceDashboardPage />} />
      <Route path={`/app/settings/personal_info`} element={<MyProfile />} />
      <Route
        path={`${baseUrl}/dashboard/ai-alerts/pre-diagnostics/:aiAlertId/`}
        element={<PreAiAlertDiagnostics />}
      />
      <Route
        path={`${baseUrl}/dashboard/ai-alerts/pre-ad-diagnostics/:aiAlertId/`}
        element={<PreAdAiAlertDiagnostics />}
      />
      <Route
        path={`${baseUrl}/dashboard/ai-alerts/diagnostics/:id`}
        element={<RemountHoC Component={AiAlertDiagnostics} />}
      />

      <Route path={`${baseUrl}/dashboard/ai-cohorts`} element={<VideoAIAlertsCohorts />} />
      <Route path={`${baseUrl}/dashboard/ai-alerts`} element={<AiAlertsPage />} />
      <Route path={`${baseUrl}/dashboard/temp/:type`} element={<TempDashboard />} />

      <Route path={`${baseUrl}/settings/webhooks`} element={<WebhooksListPage />} />
      <Route path={`${baseUrl}/settings/webhooks/edit/:id`} element={<WebhooksEditPage />} />
      <Route path={`${baseUrl}/settings/webhooks/edit`} element={<WebhooksEditPage />} />
      <Route path={`${baseUrl}/account/details`} element={<AccountDetails />} />
      <Route path={`/app/settings/ssd`} element={<SsdPanel />} />
      <Route path={`/app/settings/session_tag`} element={<SessionTagPanel />} />

      {/* <Route
          path={`${baseUrl}/admin/persistence`}
          component={PersistenceAdmin}
        /> */}
      <Route path={`${baseUrl}/dashboard/ai-roadmap`} element={<AIRoadmapPage />} />

      <Route path={`${baseUrl}/nx/ask`} element={<AskNexa />} />
      <Route path={`${baseUrl}/nx/share/:id`} element={<NexaSharedView />} />
      <Route path={`${baseUrl}/dashboard/nexa`} element={<RedirectToNexaWithId />} />
      <Route
        path={`${baseUrl}/dashboard/nexa/:id`}
        element={<RemountHoC Component={NexaDashboard} />}
      />

      <Route element={<PageNotFound />} />
    </Routes>
  );
};

export default VideoAdRouter;
